import { InternalRefetchQueriesInclude, useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { CreateStreamInvitesInput } from '@/__generated__/graphql.ts';
import { gql } from '@/__generated__/index.ts';

const InviteUsersToStream = gql(`
  mutation InviteUsersToStream($input: CreateStreamInvitesInput!) {
    createStreamInvites(input: $input) {
      id
    }
  }
`);

export const useInviteUsersToStream = (
  streamId: string,
  refetchQueries?: InternalRefetchQueriesInclude,
) => {
  const toast = useToast();

  const [inviteUsersToStreamMutation, result] = useMutation(
    InviteUsersToStream,
    {
      onError: () => {
        toast.error({
          title: 'Failed to invite users',
          subTitle: 'Please try again',
        });
      },
      onCompleted: () => {
        toast.info({
          title: 'Users successfully invited',
        });
      },

      refetchQueries,
    },
  );

  const inviteUsersToStream = (
    input: Omit<CreateStreamInvitesInput, 'streamId'>,
  ) => {
    return inviteUsersToStreamMutation({
      variables: {
        input: {
          streamId,
          ...input,
        },
      },
    });
  };

  return [inviteUsersToStream, result] as const;
};
